import * as redux from 'redux';
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage'

import * as reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
}

export default () => {
  let store = redux.createStore(persistReducer(persistConfig, redux.combineReducers(reducers)));
  let persistor = persistStore(store);
  return {store, persistor};
}